<template>
    <div>
        <CommonLogin :login="login" :action="LOGIN" :propMobile="mobile" />
    </div>
</template>

<script>
import { LOGIN } from "@/enum/MEMBER_IMG_CODE_TYPE.js";
import CommonLogin from "../../components/common-login/CommonLogin.vue";
import userLoginToJudge from "../../services/userLoginToJudge.js";
export default {
    props: {
        from: {
            type: String,
            default: "",
        },
        saveKey: {
            type: String,
            require: true,
        },
        mobile: String,
        next: Function,
    },
    data() {
        this.LOGIN = LOGIN;
        return {};
    },
    components: { CommonLogin },
    methods: {
        login(data) {
            return this.$http({
                loading: true,
                url: "/bdzb-permission/usr/login",
                data: { ...data },
                method: "POST",
            }).then((data) => {
                console.log(data, "login");
                window.sessionStorage.setItem(
                    `INVERTADVISER_WX_MEMBER_${this.saveKey}`,
                    JSON.stringify(data)
                );
                userLoginToJudge().then(() => {
                    if (this.next) {
                        this.next().then(() =>
                            this.$router.replace("/user-report")
                        );
                    } else {
                        if (/login/.test(this.from)) {
                            this.$router.replace("/");
                        } else {
                            this.$router.replace(`/${this.from}`);
                        }
                    }
                });
            });
        },
    },
};
</script>
